import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import Parser from 'html-react-parser';
import "./ExclusiveCoffees.css";

export const ExclusiveCoffees = ({token}) => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [signUpUrl, setSignUpUrl] = useState('');
  const [userId, setUserId] = useState('');
  const [phoneEntered, setPhoneEntered] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputClasses, setInputClasses] = useState(["topText"]);
  const [topClasses, setTopClasses] = useState(["top"]);
  const [welcomeClasses, setWelcomeClasses] = useState(["phoneWelcome", "landingHidden", "landingHiddenVisually"]);
  const [phoneErrorClasses, setPhoneErrorClasses] = useState(["phoneError", "landingHidden"]);
  const [phoneInputSectionClasses, setPhoneInputSectionClasses] = useState(["phoneInputs"]);
  const [emailInputSectionClasses, setEmailInputSectionClasses] = useState(["emailInputs", "landingHidden"]);
  const [joinText, setJoinText] = useState('JOIN FELLOW DROPS:');
  const [freeToJoinText, setFreeToJoinText] = useState('*Free to join. Message and data rates may apply.<br/>Reply STOP to opt-out anytime');

  const onEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const onPhoneChange = (event) => {
    const value = event.target.value;
    const stripped = value.replace(/\D/g, '');

    const l = stripped.length;
    if (l<=3) {
      setPhone(stripped);
    } else if (l > 3 && l < 7) {
      setPhone(stripped.replace(/^(\d{3})(\d+)$/, '($1) $2'));
    } else if (l>=10) {
      setPhone(stripped.replace(/^(\d{3})(\d{3})(\d{4}).*$/, '($1) $2 $3'));
    } else {
      setPhone(stripped.replace(/^(\d{3})(\d{3})(\d+)$/, '($1) $2 $3'));
    }
  };

  const textMeClick = async (event) => {
    event.preventDefault();

    let currentPhone = phone;
    if (currentPhone === '') {
        currentPhone = document.getElementById('topPhone').value;
    }

    const response = await fetch('/phonesignup', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({
        phone: currentPhone,
        utm_source: searchParams.get('utm_source'),
        utm_content: searchParams.get('utm_content'),
        utm_medium: searchParams.get('utm_medium'),
        utm_campaign: searchParams.get('utm_campaign')
      })
    }).then(response => {
        response.json().then(data => {
            if (data.error) {
                setPhoneErrorClasses(phoneErrorClasses.filter(item => item.indexOf('landingHidden') < 0 ));
                setPhoneError(data.error);
            } else {
                setPhoneErrorClasses(current => [...current, 'landingHidden']);
                setPhoneError('');
                setPhoneInputSectionClasses(['landingHidden']);
                setEmailInputSectionClasses(['emailInputs']);
                setJoinText('Step 2: Can we get your email?');
                setFreeToJoinText("You're in! Now complete your account details for seamless ordering of our super-limited coffees!");
                setSignUpUrl(data.url);
                setUserId(data.customer_id);
                setInputClasses(current => [...current, 'topTextBlue']);
                setTopClasses(current => [...current, 'topBlue']);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'location': 'topLeftInputContainer',
                    //'phone': data.phone,
                    'user_id': data.id,
                    'event': 'phone_number_submission'
                });

            }
        })
    });
  };

  const signUpClick = async (event) => {
    event.preventDefault();
    let currentEmail = email;
    if (currentEmail === '') {
        currentEmail = document.getElementById('topEmail').value;
    }
    const response = await fetch('/signupupdateemail', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({
        id: userId,
        email: currentEmail
      })
    }).then(response => {
        response.json().then(data => {
            if (data.error) {
                setPhoneErrorClasses(phoneErrorClasses.filter(item => item.indexOf('landingHidden') < 0 ));
                setPhoneError(data.error);
                setPhoneInputSectionClasses(['phoneInputs']);
                setEmailInputSectionClasses(['emailInputs', 'landingHidden']);
            } else {
                /*
                window.dataLayer.push({
                    'location': 'topLeftInputContainer',
                    //'phone': data.phone,
                    'user_id': userId,
                    'event': 'signup_click'
                });*/
                window.location.href = signUpUrl;

                /*
                setUserId(data.id);
                setPhoneEntered(data.phone);
                setSignUpUrl(data.url);
                setInputClasses(current => [...current, 'landingHidden']);
                setWelcomeClasses(welcomeClasses.filter(item => item.indexOf('landingHidden') < 0 ));
                */
            }
        });

    });
  };

  const letsGoClick = () => {
    //navigate(signUpUrl);
    window.dataLayer.push({
        'location': 'topLeftInputContainer',
        //'phone': data.phone,
        'user_id': userId,
        'event': 'signup_click'
    });
    window.location.href = signUpUrl;
  };
/*
  useEffect(() => {
    fetch('/csrf', {
    }).then(response => {
        setToken(response.headers.get('X-CSRFToken'));
    });
  }, []);
*/
  return (
    <div id="sign-up" className={topClasses.join(' ')} >

        <div className="topHeader" >
            
            <div className="topHeaderCaption">
              <div className="topHeaderCaptionDiv">
                <div className="topHeaderCaptionText">
                Exclusive and limited coffees,<br/>meticulously curated.
                </div>
              </div>
            </div>
             <img className={process.env.REACT_APP_HEADER_IMAGE_CLASS} />
        </div>

        <div id="topWelcome" className={welcomeClasses.join(' ')}>
            <div className="phoneWelcomeLeft">
                <div className="phoneWelcomeLeftStickers">
                  <div className="phoneWelcomeToDropsSticker">
                    <img alt="Welcome to Drops" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/welcome_to_drops.png"} width="223" height="159"/>
                  </div>
                  <div className="phoneWelcomeBeanzSticker">
                    <img alt="Beanz" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/beanz_3.png"} width="102" height="102"/>
                  </div>
                </div>
            </div>
            <div className="phoneWelcomeMiddle">
                <div className="phoneWelcomeTitle">
                  <img alt="Party Left" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/party.png"} className="phoneWelcomePartyImg"/>
                  <div className="phoneWelcomeTitleText">Welcome to Drops!</div>
                  <img alt="Party Right" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/party.png"}/>
                </div>
                <div className="phoneWelcomeText">
                You signed up with <span id="topPhoneEntered">{phoneEntered}</span>.<br/>Look out for a welcome text now.
                </div>
                <div className="phoneWelcomeSubtext">
                Psst... want to get ahead of the curve?<br/>Save a shipping address now for easier purchases.
                </div>
                <div id="topWelcomeLink" className="phoneWelcomeLetsGo" onClick={letsGoClick}>
                     <div className="phoneWelcomeLetsGoText">
                     LET'S GO
                     </div>
                </div>
            </div>
            <div className="phoneWelcomeRight">
                <div className="phoneWelcomeRightStickers">
                  <div className="phoneWelcomeCheckPhoneSticker">
                    <img alt="Check Your Phone" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/check_your_phone.png"} width="206" height="197"/>
                  </div>
                  <div className="phoneWelcomeMugSticker">
                    <img alt="Mug" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/mug_sticker2.png"} width="90" height="90"/>
                  </div>
                </div>
            </div>
        </div>

        <div id="topText" className={inputClasses.join(' ')} >
            <div className="topLeft">
                <div className="topLeftTitle" >
                Fellow Drops
                </div>
                <div className="topLeftText" >
                Discover the best new coffees in the world right now, tried and tested by the people who drink way too much of it.
                </div>
            </div>
            <div className="topMiddle">
                <div className="topMiddleSticker">
                    <img alt="New Roast Who Dis?" className="topMiddleImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/new_roast.png"} width="100%" height="100%"/>
                </div>
                <div className="topMiddleSticker2">
                    <img alt="Coffee Bloom" className="topMiddleImg2" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/coffee_bloom_red.png"} width="100%" height="100%"/>
                </div>
            </div>
            <div className="topRight">
                <div id="topPhoneEntry">
                    <div className="topLeftJoin">
                        {Parser(joinText)}
                    </div>
                    <div className="topLeftInputs">
                      <div className={phoneInputSectionClasses.join(' ')}>
                        <div className="topLeftInputContainer" id="topLeftInput" >
                            <div>
                                <input id="topPhone" className="topLeftInput" autoComplete="on" inputMode="tel" type="tel" value={phone} onChange={onPhoneChange} onkeypress="{(event) => return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 14)) }" placeholder="PHONE NUMBER" />
                         
                            </div>
                        </div>
                        <div id="topNext" className="topLeftTextMe" onClick={textMeClick}>
                            <div className="topLeftTextMeText">
                            TEXT ME
                            </div>
                        </div>
                      </div>

                      <div className={emailInputSectionClasses.join(' ')}>
                        <div className="topLeftInputContainer" id="topLeftInput" >
                            <div>
                                <input id="topEmail" className="topLeftInput" value={email} type="tel" onChange={onEmailChange} onkeypress="{(event) => return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 14)) }" placeholder="EMAIL" />
                         
                            </div>
                        </div>
                        <div id="topSubmit" className="topLeftSignUp" onClick={signUpClick}>
                            <div className="topLeftTextMeText">
                            SIGN UP
                            </div>
                        </div>
                      </div>


                    </div>

                    <div id="topPhoneError" className={phoneErrorClasses}>
                        {Parser(phoneError)}
                    </div>

                    <div className="topLeftFree">
                    {Parser(freeToJoinText)}
                    </div>
                </div>
            </div>

        </div>
    </div>
  );
}

